import { render } from "./Reminder.vue?vue&type=template&id=de386f7a&scoped=true"
import script from "./Reminder.vue?vue&type=script&lang=js"
export * from "./Reminder.vue?vue&type=script&lang=js"

import "./Reminder.vue?vue&type=style&index=0&id=de386f7a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de386f7a"]])

export default __exports__